import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { AmIconComponent } from './am-icon.component';
import { OsIconsService } from './os-icon.service';

@NgModule({
  declarations: [AmIconComponent],
  imports: [CommonModule, MatIconModule, HttpClientModule],
  exports: [AmIconComponent],
  providers: [OsIconsService],
})
export class AmIconModule {}
